import { useHistory, useRouteMatch } from 'react-router';

import { QrCodeIcon, EllipsisVerticalIcon } from '@heroicons/react/20/solid';
import SVGIcon from '../SVGIcon/SVGIcon';

interface TrailFooterButtonProps {
  onClick: () => void;
  label: string;
  children: React.ReactNode;
}

function TrailFooterButton({
  onClick,
  label,
  children,
}: TrailFooterButtonProps) {
  return (
    <button
      type="button"
      className="group hover:bg-mt-surface-2 inline-flex flex-col items-center justify-center px-5"
      onClick={onClick}
    >
      {children}
      <span className="text-mt-ink-muted group-hover:text-mt-primary mt-1 text-sm">
        {label}
      </span>
    </button>
  );
}

const iconClassName =
  'mb-1 h-5 w-5 text-mt-primary group-hover:text-mt-primary';

export interface Props {
  openMenu: () => void;
}

function TrailFooter({ openMenu }: Props) {
  // useRouteMatch().path is the route PATTERN (e.g. `/trail/:trailId`), not
  // the resolved path — pushing `${path}/scan` navigated to the literal,
  // unresolved `/trail/:trailId/scan`. `url` is the actual resolved path
  // (e.g. `/trail/abc123`), matching what ModalRouter itself matches against.
  let { url } = useRouteMatch();
  let history = useHistory();
  return (
    <div className="Trail_footer border-mt-border-soft bg-mt-surface h-16 w-full border-t">
      <div className="mx-auto grid h-full max-w-lg grid-cols-3 font-medium">
        <TrailFooterButton
          onClick={() => {
            history.push(`${url}/scan`);
          }}
          label="Scan"
        >
          <QrCodeIcon
            className={iconClassName}
            fill="currentColor"
            aria-hidden="true"
          />
        </TrailFooterButton>
        <TrailFooterButton
          onClick={() => {
            history.push(`${url}/enter-code`);
          }}
          label="Code"
        >
          <SVGIcon className={iconClassName} icon="code" />
        </TrailFooterButton>
        <TrailFooterButton onClick={() => openMenu()} label="More">
          <EllipsisVerticalIcon
            className={iconClassName}
            fill="currentColor"
            aria-hidden="true"
          />
        </TrailFooterButton>
      </div>
    </div>
  );
}

export default TrailFooter;
